<!-- Extends StandardLayout -->
<template>
  <StandardLayout>
    <template v-slot:main>
      <div class="d-flex flex-row flex-1 ideaverse-black-accent--background">
        <!-- Sidebar -->
        <div class="ideaverse-black--background sidebar sidebar-layout-height" :class="{ 'show-sidebar': sidebar }">
          
          <!-- Header Control -->
          <div class="d-flex flex-row pa-4" :class="sidebar ? 'justify-end' : 'justify-center'">
            <v-btn icon color="white" @click="sidebar = !sidebar">
              <v-icon v-if="sidebar">mdi-menu-open</v-icon>
              <v-icon v-else>mdi-menu-close</v-icon>
            </v-btn>
          </div>

          <!-- Sidebar Divider -->
          <v-divider dark></v-divider>
        
          <!-- Sidebar Content -->
          <div class="sidebar-scroll">
            <slot name="sidebar" :sidebar="sidebar" />
          </div>
        </div>
        
        <!-- Main Content -->
        <main class="d-flex flex-column flex-1 chat-center ideaverse-black-accent--background main-content">
          <slot name="main" />
        </main>

      </div>
    </template>
  </StandardLayout>
</template>

<script>
import StandardLayout from '@/layouts/Standard.vue'

export default {

  name: 'SidebarLayout',

  components: {
    StandardLayout,
  },

  data() {
    return {
      sidebar: true,
    }
  },
  
}
</script>

<style lang="scss" scoped>
  .sidebar-layout-height {
    height: calc(100vh - 66px);
  }
  .sidebar {
    width: 60px;
    transition: width 0.3s ease;
    min-height: 0;
  }
  
  .show-sidebar {
    width: 300px;
  }

  .sidebar-scroll {
    min-height: 0;
    height: 100%;
    overflow-y: scroll;
  }
  
  .main-content {
    /* Ensure the main column can shrink, preventing push-down */
    min-height: 0;
  }
</style>